import React from 'react';

import type { FC } from 'react';

export const Edit: FC<React.SVGAttributes<SVGSVGElement>> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
      <path d="M2 11.6408V13.6675C2 13.8541 2.14667 14.0008 2.33333 14.0008H4.36C4.44667 14.0008 4.53333 13.9675 4.59333 13.9008L11.8733 6.62748L9.37333 4.12748L2.1 11.4008C2.03333 11.4675 2 11.5475 2 11.6408ZM13.8067 4.69415C14.0667 4.43415 14.0667 4.01415 13.8067 3.75415L12.2467 2.19415C11.9867 1.93415 11.5667 1.93415 11.3067 2.19415L10.0867 3.41415L12.5867 5.91415L13.8067 4.69415Z" />
    </svg>
  );
};
